import GroupsPage from './GroupsPage';
export { type GroupPageProps } from './types';
export default GroupsPage;
